/**
 * The maths behind a month calendar: which days go in which cell.
 *
 * Kept apart from the component because this is the part that can be wrong in
 * a way nobody notices — a grid that silently drops the 31st, or shifts a day
 * because a date was turned into a UTC string somewhere.
 */

/**
 * Local yyyy-mm-dd.
 *
 * Deliberately not `toISOString().slice(0, 10)`: that converts to UTC first,
 * so for anyone east of Greenwich a training at 01:00 lands on the previous
 * day. Bucharest is two or three hours ahead, so that is every evening
 * training in the country.
 */
export function dayKey(d: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * Every day shown for a month: whole weeks, Monday first, padded at both ends
 * with the neighbouring months' days so the seven columns always line up.
 *
 * `month` is 0-based, as in the Date constructor.
 */
export function monthGrid(year: number, month: number): Date[] {
  const first = new Date(year, month, 1);
  // getDay() is 0=Sunday; the Romanian week starts on Monday.
  const lead = (first.getDay() + 6) % 7;
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cellCount = Math.ceil((lead + daysInMonth) / 7) * 7;

  const cells: Date[] = [];
  for (let i = 0; i < cellCount; i++) {
    // Day arithmetic through the Date constructor, which rolls over month and
    // year boundaries correctly — including over a DST change, where adding
    // 24h of milliseconds would not.
    cells.push(new Date(year, month, 1 - lead + i));
  }
  return cells;
}
